let language = {
    STORE_PRODUCT_SETTING_NAVIGATION_PRODUCT_NAME:"Product",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_NAME:"Design",
    STORE_PRODUCT_SETTING_NAVIGATION_MOCKUP_NAME:"Mockup",
    STORE_PRODUCT_SETTING_NAVIGATION_INFO_NAME:"Info",
    STORE_PRODUCT_SETTING_NAVIGATION_PRICING_NAME:"Pricing",
    STORE_PRODUCT_SETTING_NAVIGATION_BINDING_NAME:"Binding",
    STORE_PRODUCT_SETTING_NAVIGATION_PHOTO_LIB_NAME:"Card Rarity",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_FIX_NAME:"Fix Design",
    STORE_PRODUCT_SETTING_NAVIGATION_DESIGN_RANDOM_NAME:"Random Design",
};

export { language }